import { render, staticRenderFns } from "./investorParticulars.vue?vue&type=template&id=38748804&scoped=true"
import script from "./investorParticulars.vue?vue&type=script&lang=js"
export * from "./investorParticulars.vue?vue&type=script&lang=js"
import style0 from "./investorParticulars.vue?vue&type=style&index=0&id=38748804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38748804",
  null
  
)

export default component.exports